import { render, staticRenderFns } from "./LegendPanel.vue?vue&type=template&id=3390c754&"
import script from "./LegendPanel.vue?vue&type=script&lang=js&"
export * from "./LegendPanel.vue?vue&type=script&lang=js&"
import style0 from "./LegendPanel.vue?vue&type=style&index=0&id=3390c754&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports